/// <amd-module name="Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionContracts" />

export interface ICommand {
    disabled: boolean;
}

export type CommandMap = { [key: string]: ICommand };

export interface ICommandState {
    /** Available commands */
    commands: CommandMap;
    /** Available view actions */
    viewActions: CommandMap;
}

export interface ICommandAwareState {
    commandsState: ICommandState;
}

export interface ICommandTogglePayload {
    key: string;
    disabled: boolean;
}
